module.exports = __webpack_public_path__ + "img/icon-fanish-disable.f88e0ba4.png";